/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';

export default function Placeholder({
    height,
    width,
    borderRadius,
    style,
    ...rest
}) {
    return (
        <div
            data-component="Placeholder"
            style={{
                ...style,
                height,
                borderRadius,
                width
            }}
            {...rest}
        />
    );
}

Placeholder.propTypes = {
    /** css value for the height, i.e. '60px' */
    height: PropTypes.string,

    /** css value for the width, i.e. '50% */
    width: PropTypes.string,

    /** css value for the border radius, i.e. '3px' */
    borderRadius: PropTypes.string,

    /** Normal React style object */
    style: PropTypes.object
};
